/* Delivery guidance only. Shopify checkout remains the delivery and tax authority. */
(() => {
  'use strict';
  const key = 'tosca-pickup-intent';
  const money = cents => new Intl.NumberFormat('en-AU', {style:'currency',currency:'AUD',maximumFractionDigits:2}).format(cents / 100);
  let pickup = false;
  try { pickup = sessionStorage.getItem(key) === 'yes'; } catch {}
  function pickupIntent() { return pickup; }
  function node(tag, text, className) {
    const n = document.createElement(tag);
    if (text !== undefined) n.textContent = text;
    if (className) n.className = className;
    return n;
  }
  function delivery(cart) {
    if (!cart?.item_count || cart.currency !== 'AUD' || cart.taxes_included || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0 || cart.items.some(i => i.selling_plan_allocation || i.handle === 'custom-printed-pet-cans')) return null;
    if (cart.items.some(i => i.taxable !== true)) return null;
    const inclusiveTotal = Math.round(cart.total_price * 1.1);
    const section = node('section', undefined, 'delivery-progress');
    section.setAttribute('aria-label', 'Delivery and pickup guide');
    const message = node('p', undefined, 'delivery-progress-message');
    const meter = node('progress');
    meter.max = 15000;
    meter.value = Math.min(inclusiveTotal, 15000);
    meter.setAttribute('aria-label', 'Order value towards the $150 including GST local-delivery threshold');
    const note = node('p', 'For eligible addresses within 40 km of Mortdale. Address eligibility, delivery and GST are confirmed at checkout.', 'delivery-progress-note');
    const label = node('label', undefined, 'pickup-intent');
    const checkbox = node('input');
    checkbox.type = 'checkbox';checkbox.checked = pickupIntent();
    label.append(checkbox, node('span', 'I plan to collect from Mortdale'));
    const update = () => {
      const pickup = pickupIntent();
      checkbox.checked = pickup;
      message.textContent = pickup ? 'Pickup is free. No extra spend needed.' : inclusiveTotal >= 15000 ? 'Your order meets the free local-delivery threshold.' : money(15000 - inclusiveTotal) + ' including GST away from free local delivery.';
      meter.hidden = pickup;
      note.textContent = pickup ? 'Choose pickup at checkout and wait for your pickup-ready confirmation before travelling.' : 'For eligible addresses within 40 km of Mortdale. Address eligibility, delivery and GST are confirmed at checkout.';
    };
    checkbox.addEventListener('change', () => {
      pickup = checkbox.checked;
      try { sessionStorage.setItem(key, pickup ? 'yes' : 'no'); } catch {}
      // This preference only changes guidance; it never selects a checkout service.
      document.dispatchEvent(new CustomEvent('tosca:delivery-intent'));
      update();
    });
    section._refreshDelivery = update;
    section.append(message, meter, note, label);update();return section;
  }
  document.addEventListener('tosca:delivery-intent', () => document.querySelectorAll('.delivery-progress').forEach(n => n._refreshDelivery?.()));
  function publish(name, detail) {
    // Custom feature events only; never duplicate Shopify's native commerce events.
    // No identifiers, email, address or cart token are included.
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true) return;
      window.Shopify?.analytics?.publish?.(name, detail);
    } catch {}
  }
  window.ToscaRefinements = {delivery, publish};
})();
